export default "__VITE_ASSET__D_uWAf1F__"